<template>
  <CustomModal ref="modal" title="Gérer le statut">
    <div class="status-modal" v-if="association">

      <div class="current-status">
        <div class="label">Statut actuel</div>
        <span class="transmission-status" :style="getTransmissionStatusStyle(currentStatus)">
          {{ getTransmissionStatus(currentStatus) }}
        </span>
      </div>

      <div class="status-separator"></div>

      <div class="modal-actions">
        <CustomForm ref="form" :inputs=inputs :submit=buttons.submit>
          <div class="available-statuses">
            <div v-if="isLoading" class="loading">Chargement des statuts possible...</div>
            <div v-else-if="inputs.statusRadio.values.length === 0" class="empty">Aucun changement de statut possible.</div>
            <CustomRadioField v-else :content="inputs.statusRadio"/>
          </div>

          <div class="buttons-container">
            <CustomButton class="submit-button" @click="closeModal" :params=buttons.back :isSecondary="true" style="margin-top: 15px"/>
            <CustomButton class="submit-button" @click="submit" :params=buttons.submit style="margin-top: 15px"/>
          </div>

        </CustomForm>
      </div>

    </div>
  </CustomModal>
</template>

<script>
import { InvoiceTransmissionAssociationController } from "@/invoice-transmission/controllers/invoice_transmission/InvoiceTransmissionAssociationController";
import {getTransmissionStatus, getTransmissionStatusStyle} from "../../utils";
import CustomModal from "@/components/modals/CustomModal.vue";
import CustomForm from "@/components/forms/CustomForm.vue";
import CustomButton from "@/components/forms/customs/customButton/CustomButton.vue";
import CustomRadioField from "@/components/forms/customs/customRadioField/CustomRadioField.vue";

export default {
  name: "InvoiceTransmissionStatusModal",
  components: {
    CustomRadioField,
    CustomButton,
    CustomForm,
    CustomModal
  },
  data() {
    return {
      association: undefined,
      currentStatus: undefined,
      isLoading: false,
      inputs: {
        statusRadio: {label: "Statut", value: "pending", values: [], required: true, readOnly: false, error: false}
      },
      buttons: {
        back: {text: "Annuler"},
        submit: {text: "Mettre à jour"}
      },
    };
  },
  methods: {
    getTransmissionStatus,
    getTransmissionStatusStyle,
    async openModal(association) {
      this.association = association;
      this.currentStatus = association?.providers?.superpdp?.status;

      this.$refs.modal.openModal();

      await this.loadAvailableStatuses();
    },
    closeModal() {
      this.inputs.statusRadio.value = undefined;
      this.$refs.modal.closeModal();
    },
    async loadAvailableStatuses() {
      this.isLoading = true;

      const resp = await InvoiceTransmissionAssociationController.getAvailableStatusTransitions(this.association._id);

      if (resp && !resp.errors) {
        this.inputs.statusRadio.values = resp.availableStatuses || [];
      }

      this.isLoading = false;
    },
    async submit() {
      if (this.inputs.statusRadio.value === undefined)
        return;

      const resp = await InvoiceTransmissionAssociationController.updateInvoiceStatus(this.association._id, this.inputs.statusRadio.value);

      if (resp && !resp.errors) {
        this.closeModal();
        console.log(resp);
      }
    }
  }
};
</script>

<style lang="stylus" scoped>
@require '~/src/common/style/common.styl'

.status-modal
  padding 10px 5px

.label
  font-size 13px
  font-weight 600
  color #666
  margin-bottom 8px

.current-status
  display flex
  flex-direction column
  align-items flex-start

.transmission-status
  display inline-block
  padding 4px 10px
  border-radius 20px
  font-size 12px
  font-weight bold

.status-separator
  height 1px
  background #e5e5e5
  margin 20px 0

.status-list
  display flex
  flex-direction column
  gap 8px

.status-option
  display flex
  align-items center
  gap 10px
  padding 10px 12px
  border 1px solid #e5e5e5
  border-radius 6px
  cursor pointer
  transition .2s

  &:hover
    background rgba(0,0,0,.03)

  input
    cursor pointer

.loading,
.empty
  color #777
  font-size 13px
  padding 10px 0

.buttons-container
  display flex
  gap 15px
</style>